const locationSl = {
  selector: {
    districtLabel: 'දිස්ත්‍රික්කය',
    upazillaLabel: 'උපසිලාව',
    bazarLabel: 'බසාර්',
    districtSearchPlaceholder: 'දිස්ත්‍රික්කය සෙවීම...',
    upazillaSearchPlaceholder: 'උපසිලාව සෙවීම...',
    bazarSearchPlaceholder: 'බසාර් සෙවීම...'
  },
  popup: {
    title: 'ඔබගේ දිස්ත්‍රික්කය, උපසිලාව සහ බසාර් තෝරන්න',
    instruction: 'ඔබට යෙදුම භාවිතා කිරීමට ඉතා පහසු වීමට පහත තෝරාගැනීම් සම්පූර්ණ කරන්න',
    chooseDistrict: 'දිස්ත්‍රික්කය තෝරන්න',
    chooseUpazilla: 'උපසිලාව තෝරන්න',
    chooseBazar: 'බසාර් තෝරන්න',
    districtSearchPlaceholder: 'දිස්ත්‍රික්කය සෙවීම...',
    upazillaSearchPlaceholder: 'උපසිලාව සෙවීම...',
    bazarSearchPlaceholder: 'බසාර් සෙවීම...',
    selectedPrefix: 'තෝරාගත්:',
    confirm: 'নিশ্চিত করুন'
  }
};

export default locationSl;


